import { render } from "./large-page.vue?vue&type=template&id=5c64f1ef&scoped=true"
import script from "./large-page.vue?vue&type=script&lang=js"
export * from "./large-page.vue?vue&type=script&lang=js"

import "./large-page.vue?vue&type=style&index=0&id=5c64f1ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c64f1ef"]])

export default __exports__